import axios, { AxiosError, AxiosResponse } from "axios";
import {
  rto_bulk_expedition_validation_url,
  rto_bulk_scan_colis_url,
  rto_bulk_validation_url,
} from "../constants/urls";
import { store } from "../store/store";
import { defaultHeadersWithToken } from "../constants/constants";
import {
  RtoBulkScanData,
  RtoBulkValidationPayload,
} from "@/interfaces/Return";
import { ServerResponse } from "@/interfaces/Server";
import { usesExpeditionBulkValidation } from "@/utils/return-rto";

const normalizeScanData = (payload: unknown): RtoBulkScanData | null => {
  if (!payload || typeof payload !== "object") return null;

  const root = payload as Record<string, unknown>;
  const data =
    root.data && typeof root.data === "object"
      ? (root.data as Record<string, unknown>)
      : root;

  if (
    !Array.isArray(data.list) ||
    typeof data.operationId !== "number"
  ) {
    return null;
  }

  return {
    operationId: data.operationId,
    list: data.list as RtoBulkScanData["list"],
  };
};

export async function scanRtoBulkColis(
  trackingCode: string
): Promise<{ data: RtoBulkScanData | null; error?: string }> {
  const accessToken = store.getState().authentication.accessToken;

  try {
    const response = await axios.get(rto_bulk_scan_colis_url(trackingCode), {
      headers: defaultHeadersWithToken(accessToken),
    });

    const data = normalizeScanData(response.data);
    if (!data) {
      return { data: null, error: "Réponse invalide du serveur" };
    }

    return { data };
  } catch (error: unknown) {
    const axiosError = error as AxiosError<{ message?: string }>;
    return {
      data: null,
      error:
        axiosError.response?.data?.message ??
        "Erreur lors du scan du colis",
    };
  }
}

export async function validateRtoBulkPickup(
  payload: RtoBulkValidationPayload
): Promise<AxiosResponse<ServerResponse<boolean>>> {
  const accessToken = store.getState().authentication.accessToken;
  const roles = store.getState().authentication.roles;
  const validationUrl = usesExpeditionBulkValidation(roles)
    ? rto_bulk_expedition_validation_url
    : rto_bulk_validation_url;

  try {
    const response: AxiosResponse<ServerResponse<boolean>> = await axios({
      url: validationUrl,
      headers: defaultHeadersWithToken(accessToken),
      data: payload,
      method: "POST",
    });
    return response;
  } catch (error: unknown) {
    return (error as AxiosError).response as AxiosResponse<
      ServerResponse<boolean>
    >;
  }
}
